export enum AssetType {
  CHEMICAL = "Chemical",
  FERTILISER = "Fertiliser",
  SEED = "Seed",
}
